import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;
export const EventKeys = {
    UPLOAD: 'UPLOAD'
};
